<template>
  <v-text-field
    ref="inputRef"
    solo
    hide-details
    placeholder="0.00"
    class="mt-1 select-input"
    :disabled="disabled"
  />
</template>

<script>
import { watch } from '@vue/composition-api';
import { useCurrencyInput } from 'vue-currency-input';

export default {
  name: 'CurrencyInput',
  props: {
    value: Number,
    options: Object,
    disabled: Boolean,
  },

  setup(props) {
    const { inputRef, setOptions, setValue } = useCurrencyInput(props.options);

    watch(
      () => props.value,
      value => {
        setValue(value);
      },
    );

    return { inputRef };
  },
};
</script>
